import { usePreviewModeContext } from "@contexts/preview-mode-context";
import useShowNewHeader from "@hooks/use-show-new-header";

import SidebarCategoryListing from "@components/store/sidebar/category-listing";
import SidebarFiltersListing from "@components/store/sidebar/filter-listing";

import { Panel, PanelCollapsibleArea, PanelLabel } from "@components/store/sidebar/list-panel";

import styles from "./main.module.scss";

const CATEGORY_PANEL_KEY = "category";
const emptyArr = [];

const Sidebar = ({
  showLeftFilter,
  isMultiLevelMenu,
  customClass = "",
  hideFilterKeys = emptyArr,
}) => {
  const showNewHeader = useShowNewHeader();

  const { previewMode } = usePreviewModeContext();

  let className = previewMode ? styles.withPreviewMode : "";

  const categoryListing = (
    <Panel eventKey={CATEGORY_PANEL_KEY} defaultOpen>
      <div className={styles.listingPanelWrapper}>
        <PanelLabel id={CATEGORY_PANEL_KEY}>SubCategories</PanelLabel>
        <PanelCollapsibleArea eventKey={CATEGORY_PANEL_KEY}>
          <div className={styles.listingPanel}>
            <SidebarCategoryListing linkClassName={styles.categoryLink} />
          </div>
        </PanelCollapsibleArea>
      </div>
    </Panel>
  );

  return (
    <div className={`${customClass} ${className} ${styles.leftSideBarList}`}>
      {showLeftFilter ? (
        <SidebarFiltersListing
          isMultiLevelMenu={isMultiLevelMenu}
          hideFilterKeys={hideFilterKeys}
          categoryListing={showNewHeader ? "" : categoryListing}
        />
      ) : (
        !showNewHeader && categoryListing
      )}
    </div>
  );
};

export default Sidebar;
